export enum OtherBuckets {
  OfferAndStore = 'offerAndStore',
  DeliveryService = 'deliveryService',
}

export const OTHER_BUCKETS_TITLE = {
  [OtherBuckets.OfferAndStore]: 'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.OFFER_AND_STORE',
  [OtherBuckets.DeliveryService]: 'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.DELIVERY_SERVICE',
};
